import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import MaterialTable from "@material-table/core";
import { Modal } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dualdot from '../../../images/dual-dot.png';
import visa from '../../../images/visa 1.png';
import eye from '../../../images/Eye.png';
import eyeoff from '../../../images/Eye off.png';

import Loader from '../../pages/Loader';
import axios from 'axios';
import Snackbars from '../../pages/Snackbars';
import card1 from '../../../images/card/v-card.png';
import jsPDF from 'jspdf';
import { CsvBuilder } from 'filefy';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import { Tooltip } from "@material-ui/core";


export const Referral_Request = () => {
    const { t } = useTranslation();
  
    const [cvvVisibility, setCVV] = useState({});
    const [selectedCardId, setSelectedCardId] = useState(null);

    
    
    const history = useHistory();
    const [authcode, setauthcode] = useState("");
    const [authcode_error, setauthcode_error] = useState("");
    const [error, setError] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success, setSuccess] = useState(false);
    const [success_msg, setSuccessMsg] = useState("");
    const [accountval, setaccountval] = useState("");
    const [amountval, setamountval] = useState("");
    const [cardidval, setcardidval] = useState("");
    const [accountidval, setaccountidval] = useState("");
    const [amountsymbole, setamountsymbole] = useState("");

    const [AddCard, setAddCard] = useState(false);
    const [loader, setLoader] = useState(false);
    const [cardarray, setcardarray] = useState([]);
    const [cardarrayoriginal, setcardarrayoriginal] = useState(["aaa"]);

    const [OTPVerification, setOTPVerification] = useState(false);
    const [GoogleAuthenticator, setGoogleAuthenticator] = useState(false);


    const [TransferAccept, setTransferAccept] = useState(false);
    const [TransferDecline, setTransferDecline] = useState(false);
    const [success_display_debit_amount, setsuccess_display_debit_amount] = useState("");
    const [success_display_card_number, setsuccess_display_card_number] = useState("");
    const [success_display_from_account, setsuccess_display_from_account] = useState("");
    const [success_display_refno, setsuccess_display_refno] = useState("");
    const [success_display_details, setsuccess_display_details] = useState("");

    const [error_display_details, seterror_display_details] = useState("");
    const [error_display_amount, seterror_display_amount] = useState("");

    useEffect(() => {
        checkauhtoken();
        handleLoadGetAllCountry();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [AccountID3, setAccountID3] = useState("");
    const [Modal3, setModal3] = useState(false);
    const openModal3 = (accountIDVal) => {
        setAccountID3(accountIDVal);
        setModal3(true);
    }
    

    const handleLoad = async () => {
    
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'auth/getreferralrequest', { headers: headers })
            .then(async function (res) {
                res = await res.data;

                if (res.code === "200") {
                    setLoader(false);
                    await setcardarrayoriginal(res.data);
                    
                    if (res.data.length > 0) {
                        let TempArrswap = [];
                        res.data.forEach(element => {
                            let status = <Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link>;
                            if(element.status=="Approved"){
                              status = <Link to="#" className="btn btn-outline-success btn-rounded">Approved</Link>;
                            }else if(element.status=="Declined"){
                              status = <Link to="#" className="btn btn-outline-danger btn-rounded">Declined</Link>;
                            }
                            let ActionBTN="-";
                            if (element.status === "Approved") {
                              ActionBTN = <div style={{ minWidth: "175px" }}>
                                <Tooltip title="Mail"><button className="btn btn-primary shadow btn-xs edit-shape" onClick={() => openModal3(element.rr_id)}><i className="fa fa-envelope-o" aria-hidden="true"></i></button></Tooltip>
                              </div>
                            }
                    
                            let swaptemp = {
                                FullName: element.fullname,
                                Email: element.email_id,
                                Phone: "+ "+element.country_code + " " + element.phone_number,
                                Status: status,
                                Action: ActionBTN,
                            };
                            TempArrswap.push(swaptemp);

                        });
                        setcardarray(TempArrswap);
                    }
                   
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const [title, setTitle] = useState("");
    const [title_error, setTitle_error] = useState("");

    const [description, setDescription] = useState("");
    const [description_error, setDescription_error] = useState("");

    const validateTitle = (value) => {
        setTitle(value);
        if (!validator.isEmpty(value)) {
            setTitle_error("");
            return true;
        } else {
            setTitle_error("Enter User Full Name");
            return false;
        }
    }

        const validateDescription = (value) => {
        setDescription(value);
        if (!validator.isEmpty(value)) {
            setDescription_error("");
            return true;
        } else {
            setDescription_error("Enter Description");
            return false;
        }
    }

    const [Email, setEmail] = useState("");
    const [EmailError, setEmailError] = useState("");
    const validateEmail = (value) => {
    setEmail(value);
    if (validator.isEmpty(value)) {
        setEmailError("Email ID is required.");
        return false;
    } else if (!validator.isEmail(value)) {
        setEmailError(t("Please Enter Correct Email Format."));
        return false;
    } else {
        setEmailError("");
        return true;
    }
    }
   
    const [CountryCode, setCountryCode] = useState("1");
    const [Phone, setPhone] = useState("");
    const [PhoneError, setPhoneError] = useState("");
    const validateCountryCode = (value) => {
    setCountryCode(value);
    }
    const validatePhone = (value) => {
        setPhone(value);
        const phoneNumberPattern = /^\d{9,13}$/;

        if (!phoneNumberPattern.test(value)) {
            setPhoneError("Invalid Phone Number");
            return false;
        }
        if (validator.isEmpty(value)) {
            setPhoneError("Phone number is required.");
            return false;
        } if (!validator.isNumeric(value)) {
            setPhoneError("Phone number is invalid.");
            return false;
        } else {
            setPhoneError("");
            return true;
        }
    }

    const handlesubmit = () => {
        if (validateTitle(title) === false) {
            setTitle_error("Enter User Full Name");
            return false;
        } else if (!validateEmail(Email)) {
            return false;
        } else if (!validatePhone(Phone)) {
            return false;
        }else if (!validateDescription(description)) {
          return false;
        }else {
            setTitle_error("");
            setLoader(true);
            setAddCard(false);

            let jsonpar = {
                fullname: title,
                email: Email,
                country_code: CountryCode,
                phone: Phone,
                description: description
            }
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            axios.post(process.env.REACT_APP_API_URL + 'auth/referral-request', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        setSuccess(true);
                        setSuccessMsg(res.message);
                        setTimeout(() => {
                            setSuccess(false);
                        }, 6000);
                        handleLoad();
                        setAddCard(false)
                        setTitle("");
                        setDescription("");
                        setPhone("");
                        setEmail("");
                    } else {
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    setError(true);
                    setErrorMsg("Oops! Something went wrong");
                    setLoader(false);
                });
        }
    }

    const [CountryData, setCountryData] = useState([]);

    const handleLoadGetAllCountry = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'findallCountries', {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setCountryData(res.data);
                } else {
                }
                handleLoad();
            })
            .catch(function (error) {
                handleLoad();
            });
    }

        const handlesubmit3 = () => {
        setModal3(false);
        setLoader(true);

        let jsonpar = JSON.stringify({
            'rr_id': AccountID3
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'auth/sendreferrallink', jsonpar, {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                setLoader(false);

                if (res.code === "200") {
                    handleLoad();
                    setAccountID3("");

                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setLoader(false);

                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    return (
      <>
        {error ? (
          <Snackbars open_close={error} type="error" message={error_msg} />
        ) : (
          ""
        )}
        {success ? (
          <Snackbars
            open_close={success}
            type="success"
            message={success_msg}
          />
        ) : (
          ""
        )}
        {/* <p> We're actively upgrading our platform. If you face any issues, please be assured our team is addressing them promptly.</p> */}

        <div className="card bg-0 bg-none">
          <div className="card-header page-title-space mobile-card-header">
            <h2 className="text-black font-w500 mb-0">Referral Requests</h2>
            <div className="mobileFullWidth">
              <Link
                to="#"
                onClick={() => setAddCard(true)}
                className="btn btn-primary btn-rounded"
              >
                + &nbsp;New Request
              </Link>
            </div>
          </div>
        </div>
        {loader === true ? (
          <div>
            <Loader open_close={loader} />
          </div>
        ) : (
          <div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card height-cstm-chart table-action-center">
                  <div className="card-body">
                    <div className="table-responsive">
                      {cardarray.length > 0 ? (
                        <MaterialTable
                          title="Referral Request List"
                          columns={[
                            { title: "Full Name", field: "FullName" },
                            { title: "Email", field: "Email" },
                            { title: "Phone", field: "Phone" },
                            {
                              title: "Status",
                              field: "Status",
                              align: "center",
                            },
                            { title: "Action", field: "Action",align: "center" },
                          ]}
                          data={cardarray}
                          options={{
                            paging: true,
                            pageSize: 5,
                            pageSizeOptions: [5, 10, 15],
                            emptyRowsWhenPaging: false,
                          }}
                        />
                      ) : (
                        <div className="d-sm-flex d-block border-0 pb-0">
                          <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                            <h4 className="fs-20 text-black mb-1 nofoundTitle">
                              Referral Request List Overview
                            </h4>
                            <span className="fs-12 nofoundText">
                              No Data Found
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal className="modal fade" show={AddCard}>
          <div className="modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">New Referral Request</h3>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group fullWidth">
                      <label className="mb-1 fullWidth">User Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter User Full Name"
                        onChange={(e) => validateTitle(e.target.value)}
                        value={title}
                      />
                      {title_error !== "" ? (
                        <label className="text-red">{title_error}</label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group fullWidth">
                      <label className="mb-1 fullWidth">Email ID</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email ID"
                        value={Email}
                        onChange={(e) => validateEmail(e.target.value)}
                      />
                      {EmailError !== "" ? (
                        <label className="text-red">{EmailError}</label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="form-group fullWidth">
                    <label className="mb-1 fullWidth">Phone number </label>
                    <div className="form-group position-relative countrybox1">
                      <select
                        className="form-control webkit-none"
                        value={CountryCode}
                        onChange={(e) => validateCountryCode(e.target.value)}
                      >
                        {CountryData &&
                          CountryData.map((row) => (
                            <option
                              value={row.phonecode}
                              key={row.country_id_pk}
                            >
                              {"+" + row.phonecode + " (" + row.name + ")"}
                            </option>
                          ))}
                      </select>
                      <i
                        className="fa fa-caret-down down-arrow"
                        aria-hidden="true"
                      ></i>
                    </div>

                    <div className="country-text-box1">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Phone number"
                        value={Phone}
                        onChange={(e) => validatePhone(e.target.value)}
                      />
                      {PhoneError !== "" ? (
                        <label className="text-red">{PhoneError}</label>
                      ) : (
                        ""
                      )}
                    </div>

                  </div>
                </div>

                
                <div className="row">
                <div className="col-md-12">
                  <div className="form-group fullWidth">
                    <label className="mb-1 fullWidth">Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      onChange={(e) => validateDescription(e.target.value)}
                      value={description}
                    />
                    {description_error !== "" ? (
                      <label className="text-red">{description_error}</label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                </div>
              </div>

              <div className="modal-footer">
                <Link
                  to="#"
                  onClick={handlesubmit}
                  className="btn btn-primary btn-rounded"
                >
                  Add Request
                </Link>
                {/* <Link to="#"  onClick={setAddCard(false)} className="btn btn-outline-light ml-3 btn-rounded">Cancel</Link> */}
                <button
                  type="button"
                  className="btn btn-outline-light ml-3 btn-rounded"
                  onClick={() => setAddCard(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal className="modal fade" show={Modal3}>
          <div className="modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Send Referral Link to User</h3>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModal3(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="col-xs-12">
                  <div className="form-group">
                    <p className="font-18">
                      Are you sure you want to send referral link again to this
                      User?
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light btn-rounded light"
                  onClick={() => setModal3(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-rounded"
                  onClick={handlesubmit3}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );

}
export default Referral_Request;